module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_1@2x.8ba87d8b.png";